// @mui material components
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

export default function CostingInfos({
  deviceId,
  purchases,
  setPurchases,
  hoursSold,
  setHoursSold,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={purchases}
            onChange={(event) => setPurchases(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Coût des achats"
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={hoursSold}
            onChange={(event) => setHoursSold(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Nombre d'heures prévues"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

/* CostingInfos.propTypes = {
  price: PropTypes.number,
  setPrice: PropTypes.func.isRequired,
  purchases: PropTypes.number,
  setPurchases: PropTypes.func.isRequired,
  hoursSold: PropTypes.number,
  setHoursSold: PropTypes.func.isRequired,
  prorataAccount: PropTypes.number,
  setProrataAccount: PropTypes.func.isRequired,
}; */
